import { t as Swiper } from "./swiper-bundle.esm.js";
//#region frontend/entrypoints/sf-ranking.js
document.addEventListener("DOMContentLoaded", () => {
	const topItemSlider = document.querySelectorAll(".swiper.p-ranking__top-item-images");
	const swiperOptions = {
		slidesPerView: 1,
		pagination: {
			el: ".p-ranking__top-item-pagination.swiper-pagination",
			clickable: true
		},
		navigation: {
			nextEl: ".p-ranking__top-item-button--next.swiper-button-next",
			prevEl: ".p-ranking__top-item-button--prev.swiper-button-prev",
			addIcons: false
		}
	};
	if (topItemSlider) topItemSlider.forEach((slider) => {
		new Swiper(slider, swiperOptions);
	});
});
//#endregion
